
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from './components/theme/ThemeProvider';
import { FontSizeProvider } from './contexts/FontSizeContext';
import Login from './pages/Login';
import Index from './pages/Index';
import Networks from './pages/Networks';
import Devices from './pages/Devices';
import Users from './pages/Users';
import AddDevice from './pages/AddDevice';
import Profile from './pages/Profile';
import Security from './pages/Security';
import Alerts from './pages/Alerts';
import Settings from './pages/Settings';
import NotFound from './pages/NotFound';
import Header from './components/layout/Header';
import Sidebar from './components/layout/Sidebar';
import ViewDevices from './pages/ViewDevices';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'sonner';
import { MapboxTokenProvider } from './contexts/MapboxTokenContext';
import { HierarchyProvider } from './contexts/HierarchyContext';
import AddMeshConnection from './pages/AddMeshConnection';
import AIAutomation from './pages/AIAutomation';

const queryClient = new QueryClient();

function App() {
  return (
    <ThemeProvider defaultTheme="dark" storageKey="viteTheme">
      <FontSizeProvider>
        <BrowserRouter>
          <QueryClientProvider client={queryClient}>
            <MapboxTokenProvider>
              <HierarchyProvider>
                <div className="min-h-screen bg-background font-sans antialiased">
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to="/login" replace />} />
                    <Route path="/dashboard" element={
                      <>
                        <Header />
                        <div className="flex">
                          <Sidebar />
                          <main className="flex-1">
                            <Index />
                          </main>
                        </div>
                      </>
                    } />
                    <Route path="/*" element={
                      <>
                        <Header />
                        <div className="flex">
                          <Sidebar />
                          <main className="flex-1">
                            <Routes>
                              <Route path="/networks" element={<Networks />} />
                              <Route path="/add-mesh-connection" element={<AddMeshConnection />} />
                              <Route path="/devices" element={<Devices />} />
                              <Route path="/users" element={<Users />} />
                              <Route path="/add-device" element={<AddDevice />} />
                              <Route path="/profile" element={<Profile />} />
                              <Route path="/security" element={<Security />} />
                              <Route path="/alerts" element={<Alerts />} />
                              <Route path="/settings" element={<Settings />} />
                              <Route path="/view-devices" element={<ViewDevices />} />
                              <Route path="/ai-automation" element={<AIAutomation />} />
                              <Route path="*" element={<NotFound />} />
                            </Routes>
                          </main>
                        </div>
                      </>
                    } />
                  </Routes>
                  <Toaster />
                </div>
              </HierarchyProvider>
            </MapboxTokenProvider>
          </QueryClientProvider>
        </BrowserRouter>
      </FontSizeProvider>
    </ThemeProvider>
  );
}

export default App;
